module.exports = __webpack_public_path__ + "img/Home2.8ef136f8.png";